import { cn } from '@/lib/utils';
import { useLanguage } from '@/contexts/LanguageContext';
import { t } from '@/i18n/translations';

export const ScrollProgress = ({ sections, activeIndex, onDotClick }) => {
  const { lang } = useLanguage();
  const labels = t(lang).sectionLabels || [];

  return (
    <div
      className="fixed right-4 xl:right-8 top-1/2 -translate-y-1/2 hidden lg:flex flex-col items-end gap-3 z-40"
      data-testid="scroll-progress-rail"
    >
      {sections.map((_, index) => (
        <button
          key={index}
          onClick={() => onDotClick(index)}
          className="group flex items-center gap-3 justify-end py-0.5"
          aria-label={`Go to ${labels[index] || index}`}
        >
          {/* Label - always visible for active, hover for others */}
          <span
            className={cn(
              'text-xs font-mono whitespace-nowrap transition-all duration-300',
              activeIndex === index
                ? 'opacity-100 text-[#C87533] translate-x-0'
                : 'opacity-0 group-hover:opacity-100 text-white/50 translate-x-2 group-hover:translate-x-0'
            )}
          >
            {labels[index] || ''}
          </span>

          {/* Connector line for active */}
          {activeIndex === index && (
            <span className="w-6 h-px bg-[#C87533]/50" />
          )}

          {/* Dot */}
          <span
            className={cn(
              'block rounded-full transition-all duration-300 flex-shrink-0',
              activeIndex === index
                ? 'w-3 h-3 bg-[#C87533] shadow-[0_0_12px_rgba(200,117,51,0.5)]'
                : 'w-2 h-2 bg-white/25 hover:bg-white/50 group-hover:scale-125'
            )}
          />
        </button>
      ))}
    </div>
  );
};
